"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicLoadManualStaticSubappAndSpa = exports.DynamicLoadManualStatic = exports.DynamicLoadManualManager = exports.Microfrontend = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const features_1 = require("../features");
Object.defineProperty(exports, "DynamicLoadManualManager", { enumerable: true, get: function () { return features_1.DynamicLoadManualManager; } });
Object.defineProperty(exports, "DynamicLoadManualStatic", { enumerable: true, get: function () { return features_1.DynamicLoadManualStatic; } });
Object.defineProperty(exports, "DynamicLoadManualStaticSubappAndSpa", { enumerable: true, get: function () { return features_1.DynamicLoadManualStaticSubappAndSpa; } });
const ReactDOM = __importStar(require("react-dom"));
const MICROFRONTEND = 'microfrontend';
const Microfrontend = ({ id, data, loader, onLoad }) => {
    (0, react_1.useEffect)(() => {
        const loadVertical = async () => {
            await loader.loadVertical(id, data);
            onLoad && onLoad();
        };
        loadVertical();
        return () => {
            const root = document.getElementById(`${MICROFRONTEND}`);
            root && ReactDOM.unmountComponentAtNode(root);
        };
    }, []);
    return (0, jsx_runtime_1.jsx)("div", { "data-testid": `${MICROFRONTEND}-${id}`, id: MICROFRONTEND });
};
exports.Microfrontend = Microfrontend;
//# sourceMappingURL=Microfrontend.js.map